import React from "react";
import SuperadminHeader from "../components/Superadmin/SuperadminHeader";
import SuperadminSidebar from "../components/sidebar/SuperadminSidebar";
import "./SuperadminLayout.css";

const SuperadminLayout = ({ children }) => {
  return (
    <div className="superadmin-layout wrapper">
      <SuperadminHeader />
      <SuperadminSidebar />
      <div className="superadmin-layout-body content-wrapper" style={{ minHeight: '100vh' }}>
        <main className="content">{children}</main>
      </div>
    </div>
  );
};

export default SuperadminLayout;
